import { appEnv } from '@/app/config/env';
import { Analytics } from '@/app/libs/analytics/instance';

if (import.meta.env.PROD) {
  Analytics.initialize(appEnv.analyticsId);
}
